document.addEventListener("DOMContentLoaded", () => {
  console.log('check age enabled');
  const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/;`;
  };

  const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      let cookieTrimmed = cookie.trim();
      if (cookieTrimmed.indexOf(nameEQ) === 0) {
        return cookieTrimmed.substring(nameEQ.length, cookieTrimmed.length);
      }
    }
    return null;
  };

  const choice = getCookie("ageConfirmed") || sessionStorage.getItem("ageConfirmed");
  const popupCheckAge = document.getElementById("popup-check_age");
  const noButton = document.getElementById("no-button");
  const yesButton = document.getElementById("yes-button");

  if (choice === "no") {
    window.location.href = "/";
  } else if (choice !== "yes") {
    popupCheckAge.classList.add("active");
  }

  yesButton.addEventListener("click", () => {
    if (document.getElementById("no-show-again").checked) {
      setCookie("ageConfirmed", "yes", 30);
    } else {
      sessionStorage.setItem("ageConfirmed", "yes");
    }
    popupCheckAge.classList.remove("active");
  });

  noButton.addEventListener("click", () => {
    if (document.getElementById("no-show-again").checked) {
      setCookie("ageConfirmed", "no", 30);
    } else {
      sessionStorage.setItem("ageConfirmed", "no");
    }
    window.location.href = "/";
  });
});
